import { Modal, Text, Stack, Group, Divider } from "@mantine/core"
import { IconTrash } from "@tabler/icons-react"
import { Button, EqualWidthGrid } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { SupplierResponses } from "@tfg/types/endpoints/supplier"

import { useDeleteProductionSiteMutation } from "~/pages/SupplierPortal/ProductionSites/hooks/useDeleteProductionSiteMutation.ts"

interface Props {
  isOpen: boolean
  onClose: () => void
  productionSite: SupplierResponses.ProductionSite
}

export const DeleteProductionSiteModal = ({
  isOpen,
  onClose,
  productionSite,
}: Props) => {
  const { t } = useTranslation("supplier")

  const { mutate: deleteProductionSite, isPending: isLoading } =
    useDeleteProductionSiteMutation(productionSite.id)

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title={
        <Stack>
          <Text fw={700} size="lg">
            {t("productionSiteModal.delete.title")}
          </Text>
        </Stack>
      }
    >
      <Stack>
        <Divider w="100%" />
        <Stack>
          <Text>{t("productionSiteModal.delete.message")}</Text>
          <Group gap="var(--mantine-spacing-xxs)">
            <Text fw={700}>{productionSite.name}</Text>
            <Text size="xs">{productionSite.address}</Text>
          </Group>
        </Stack>
        <EqualWidthGrid>
          <Button
            variant="secondary-critical"
            onClick={() => onClose()}
            fullWidth={true}
          >
            {t("productionSiteModal.delete.cancel")}
          </Button>
          <Button
            onClick={() => {
              deleteProductionSite()
              onClose()
            }}
            loading={isLoading}
            fullWidth={true}
            color="red"
            icon={<IconTrash />}
          >
            {t("productionSiteModal.delete.confirm")}
          </Button>
        </EqualWidthGrid>
      </Stack>
    </Modal>
  )
}
